import { useRef, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { CalendarInput } from "../components/FormComps";
import { getApiSetting, postApiSetting } from "../assets/functions";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";
import { ButtonSpinner } from "../components/UI";
import DashboardCharts from "../components/DashboardCharts";

export default function DashboardPayout ({setAuth}) {
     const navigate = useNavigate();

    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);
    const [searchLoading, setSearchLoading] = useState(false);

    const [boxData, setBoxData] = useState({
        successCount : '',
        successAmt : '',
        failCount : '',
        failAmt : '',
    });

    useEffect(()=>{
        (async()=>{
            try {
                let res = await fetch('/Admin/api/Admin/dbDataPayout', getApiSetting());
                // console.log("res--",res)
                // console.log("result--",result)
                if(res.status === 200){
                    let result = await res.json();
                    // console.log("result--",result)
                    if(result.data){
                        updateDashboardData(result.data)
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    },[])

    const searchData = async () => {
        let fDate = fromDateRef.current.value;
        let tDate = toDateRef.current.value;
        
        if(!fDate || !tDate) {
            alert('Report date are required.')
            return false;
        }
        setSearchLoading(true)
        try {
            let postSetting = postApiSetting({fDate,tDate})
            let res = await fetch('/Admin/api/Admin/dbDataByDatePayout', postSetting);
            // console.log("res search by date-",res)
            if(res.status === 200){
                   let result = await res.json();
                //   console.log("result search by date-",result)
                    if(result.data){
                         updateDashboardData(result.data)
                         updateDashboardData(result.data)
                    }
                    else{
                        console.log("No result.data")
                    }
                }
                 else if(res.status === 401)
                {
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");
                    sessionStorage.clear();
                }


        } catch (error) {
            console.log(error)
        } finally {
            setSearchLoading(false)
        }
    }

    const updateDashboardData = (data) => {
        setBoxData(prevState => ({
            ...prevState,
            successCount: data.successTxnCount||0,
            successAmt: data.successTxnAmount/100,
            failCount: data.failureTxnCount||0,
            failAmt: data.failureTxnAmount/100,
        }));
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <section className="dashboard-page">
            <Navbar title="DASHBOARD" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <p className="text-secondary mb-4">Payout activity for the selected date range.</p>
                    <form className="mb-4">
                            <div className="row align-items-end">
                                <div className="col-md-3 col-lg-2">
                                    <CalendarInput label="From Date" dateRef={fromDateRef} />
                                </div>
                                <div className="col-md-3 col-lg-2">
                                    <CalendarInput label="To Date" dateRef={toDateRef} />
                                </div>
                                <div className="col-md-3 col-lg-2">
                                    <button type="button" className="btn btn-sm text-white _themebg-0" onClick={searchData} disabled={searchLoading}>
                                        {searchLoading && <ButtonSpinner />}Search</button>
                                </div>
                            </div>
                    </form>
                    <div className="row stat-card-row">
                        <StatCard text='Successful Transactions' variant='primary' value={boxData.successCount} icon={<i className="fa-solid fa-chart-line"></i>} />
                        <StatCard text='Collection Amount' variant='success' value={boxData.successAmt} icon={<i className="fa-solid fa-sack-dollar"></i>} />
                        <StatCard text='Failed Transactions' variant='danger' value={boxData.failCount} icon={<i className="fa-solid fa-magnifying-glass-dollar"></i>} />
                        <StatCard text='Failed Amount' variant='danger' value={boxData.failAmt} icon={<i className="fa-solid fa-handshake"></i>} />
                    </div>
                    <DashboardCharts boxData={boxData} />
                </div>
            </div>
        </section>
    </>)
}

const StatCard = ({ text, value, icon, variant }) => {
    const displayValue = Number.isFinite(value) ? value.toLocaleString('en-IN') : (value || '0');
    return (
        <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
            <div className={`stat-card stat-card--${variant}`}>
                <span className="stat-card__icon">{icon}</span>
                <div>
                    <p className="stat-card__label">{text}</p>
                    <strong className="stat-card__value">{displayValue}</strong>
                </div>
            </div>
        </div>
    )
}